import * as Yup from 'yup'

import clsx from 'clsx'
import { useAuth } from "../../../modules/auth"
import { useFormik } from 'formik'
import { useImpersonateMutation } from '../../services/auth'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

export const ImpersonatePage = () => {
    const { user, saveAuth, setUser, siteId } = useAuth()

    const [loading, setLoading] = useState(false)
    const [impersonate] = useImpersonateMutation()
    const navigate = useNavigate()

    const formSchema = Yup.object().shape({
        userName: Yup.string()
            .min(3, 'Minimum 3 symbols')
            .max(50, 'Maximum 50 symbols')
            .required('User name is required'),
    })

    const initialValues = {
        userName: '',
    }

    const formik = useFormik({
        initialValues,
        validationSchema: formSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            if (!user || !siteId) {
                setStatus('The user is not valid, or there are no login details in the context.')
                return;
            }

            setLoading(true)
            setSubmitting(true)

            impersonate({ userName: user.userName, impersonateUserName: values.userName, portalId: siteId })
                .unwrap()
                .then((result) => {
                    saveAuth(result.auth)
                    setUser(result.user)
                    const targetUrl = `/site(${siteId})/dashboard`
                    navigate(targetUrl)

                    setTimeout(() => {
                        window.location.href = targetUrl
                    }, 100)
                })
                .catch(err => {
                    saveAuth(undefined)
                    setStatus(err.data.message || 'An error was encountered while attempting to impersonate the user.')
                })
                .finally(() => {
                    setLoading(false);
                    setSubmitting(false)
                })
        },
    })

    return <>
        <form
            className='form'
            onSubmit={formik.handleSubmit}
            noValidate
            id='kt_login_signin_form'
        >
            <div className='card fs-7'>
                <div className='card-body'>
                    <div className='fv-fow'>
                        <label className='form-label fw-bold text-dark mb-1'>Roll Number</label>
                        <input
                            placeholder='User Name'
                            {...formik.getFieldProps('userName')}
                            className={clsx(
                                'form-control form-control-sm form-control-solid',
                                { 'is-invalid': formik.touched.userName && formik.errors.userName },
                                { 'is-valid': formik.touched.userName && !formik.errors.userName, }
                            )}
                            type='text'
                            name='userName'
                            autoComplete='off'
                        />
                        {formik.touched.userName && formik.errors.userName && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fs-8'>
                                    <span role='alert'>{formik.errors.userName}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {formik.status && (
                        <div className='mt-5 text-danger fst-italic fw-semibold'>{formik.status}</div>
                    )}
                </div>
                <div className='card-footer border-0 mt-0 pt-0'>
                    <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className='btn btn-sm btn-primary'
                        disabled={formik.isSubmitting || !formik.isValid}
                    >
                        {!loading && <span className='indicator-label'>Impersonate</span>}
                        {loading && (
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>

                </div>
            </div>
        </form>
    </>
}
